"use client"

import { useState, useEffect } from "react"
import { FiCode, FiDatabase, FiSmartphone, FiGlobe, FiCpu, FiGitBranch } from "react-icons/fi"

import "./HeroSection.css"


const HeroSection = () => {
    const [typedText, setTypedText] = useState("")
    const fullText = "Reactiva"

    useEffect(() => {
        let index = 0
        const timer = setInterval(() => {
            if (index < fullText.length) {
                setTypedText(fullText.slice(0, index + 1))
                index++
            } else {
                clearInterval(timer)
            }
        }, 150)

        return () => clearInterval(timer)
    }, [])

    const floatingElements = [
        { icon: FiCode, delay: 0, x: 10, y: 20 },
        { icon: FiDatabase, delay: 0.5, x: 80, y: 10 },
        { icon: FiSmartphone, delay: 1, x: 15, y: 70 },
        { icon: FiGlobe, delay: 1.5, x: 85, y: 60 },
        { icon: FiCpu, delay: 2, x: 50, y: 15 },
        { icon: FiGitBranch, delay: 2.5, x: 70, y: 80 },
    ]

    const codeSnippets = [
        "{ success: true }",
        "npm install",
        "git commit -m",
        "const app = ()",
        "API Response",
    ]

    return (
        <section className="hero-section">
            {/* Animated Background */}
            <div className="hero-background">
                <div className="gradient-mesh"></div>
                <div className="floating-shapes">
                    {[...Array(20)].map((_, i) => (
                        <div
                            key={i}
                            className="floating-shape"
                            style={{
                                left: `${Math.random() * 100}%`,
                                top: `${Math.random() * 100}%`,
                                animationDelay: `${Math.random() * 10}s`,
                                animationDuration: `${15 + Math.random() * 10}s`,
                            }}
                        />
                    ))}
                </div>
            </div>

            {/* Floating Tech Icons */}
            <div className="floating-icons">
                {floatingElements.map((element, index) => {
                    const IconComponent = element.icon
                    return (
                        <div
                            key={index}
                            className="floating-icon"
                            style={{
                                left: `${element.x}%`,
                                top: `${element.y}%`,
                                animationDelay: `${element.delay}s`,
                            }}
                        >
                            <IconComponent size={24} />
                        </div>
                    )
                })}
            </div>

            {/* Floating Code Snippets */}
            <div className="code-snippets">
                {codeSnippets.map((snippet, index) => (
                    <div
                        key={index}
                        className="code-snippet"
                        style={{
                            left: `${60 + Math.random() * 35}%`, // Solo lado derecho (60% - 95%)
                            top: `${15 + Math.random() * 70}%`, // Altura completa pero más controlada
                            animationDelay: `${index * 0.8}s`,
                        }}
                    >
                        {snippet}
                    </div>
                ))}
            </div>

            {/* Main Content */}
            <div className="hero-container">
                <div className="hero-content">

                    <div className="hero-text">
                        <h1 className="hero-title">
                            <span className="company-name">
                                {typedText}
                                <span className="cursor">|</span>
                            </span>
                            <span className="company-subtitle">Soporte y Desarrollo S.A.S</span>
                        </h1>

                        <div className="divider">
                            <div className="divider-line"></div>
                            <div className="divider-dot"></div>
                        </div>

                        <p className="hero-description">
                            En <strong className="highlight">Reactiva</strong> nos enfocamos en sectores de: Servicios públicos,
                            transportes, crediticios y gestión humana.
                        </p>
                    </div>

                    <div className="hero-actions">
                        <a href="#about" className="primary-btn">
                            Nosotros
                            
                        </a>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default HeroSection
